import { formatName } from '@pickleballinc/lib/format-name';
import { getCountryFlagUrl } from '@pickleballinc/lib/getCountryFlagUrl';

import { Player } from '@/entities/player-details/PlayerBanner';
import { PlayerRole } from '@/lib/types';

interface Props {
	player: Player;
	isFreeAgent: boolean;
}

export const PlayerDetailsProfileHeader = ({ player, isFreeAgent }: Props) => {
	return (
		<div className="flex flex-col gap-2 w-fit">
			<div className="flex items-center gap-1">
				<h2 className="text-[22px] sm:text-2xl font-normal leading-8 text-gray-900">{player.firstName}</h2>
				{player.showMiddleNameToPublic && player.middleName ? (
					<h2 className="text-[22px] sm:text-2xl font-normal leading-8 text-gray-900">({player.middleName})</h2>
				) : null}
			</div>
			<div className="flex items-center gap-2">
				<h1 className="text-[40px] sm:text-5xl font-bold leading-[60px] tracking-[-0.96px] text-gray-900">
					{formatName({ lastName: player.lastName, showLastNameInitialOnly: player.showOnlyFirstInitialOfLastNameToPublic })}
				</h1>

				{isFreeAgent ? (
					<span className="flex items-center justify-center text-white text-center text-sm sm:text-lg font-normal leading-7 bg-gray-900 h-[32px] w-fit rounded-[21px] px-3 text-nowrap">
						Free Agent
					</span>
				) : (
					player.playerRole === PlayerRole.TEAM_LEAGUE_TEAM_CAPTAIN && (
						<span className="flex items-center justify-center text-white text-center text-2xl font-medium leading-8 bg-gray-900 size-[30px] rounded-md">
							C
						</span>
					)
				)}
			</div>
			<div className="flex items-center gap-2 text-sm font-normal leading-5 text-gray-600">
				{player.country ? (
					<img
						src={getCountryFlagUrl(player.country.abbreviation2Digit, 100, 100)}
						alt="Icon"
						className="size-6 rounded-full object-cover"
					/>
				) : null}

				{player.country ? <span>{player.country.title}</span> : null}
				{player.professionalTitle ? <span>| {player.professionalTitle} </span> : null}
				{player.debutYear ? <span>| Debut: {player.debutYear}</span> : null}
			</div>
		</div>
	);
};
